// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sNib","selected":"styles_selected__1JTpo"};